import React from "react";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { Button } from "./ui/button";
import { Calendar } from "./ui/calendar";
import { format } from "date-fns";
import { DateRange } from "react-day-picker";
import { useIsMobile } from "../hooks/use-is-mobile";
import MobileDateRangeFields from "./mobile/mobile-date-range-fields";

type DateRangePickerProps = {
  className?: string;
  value: DateRange | undefined;
  onChange: (range: DateRange | undefined) => void;
};

const DateRangePicker: React.FC<DateRangePickerProps> = ({
  className,
  value,
  onChange,
}) => {
  const [open, setOpen] = React.useState(false);
  const isMobile = useIsMobile();

  if (isMobile) return <MobileDateRangeFields value={value} onChange={onChange} />;

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button size="sm" variant="outline" className={className}>
          {value?.from && value?.to
            ? `${format(value.from, "LLL dd, y")} - ${format(value.to, "LLL dd, y")}`
            : "Pick a date range"}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar
          mode="range"
          selected={value}
          onSelect={onChange}
          numberOfMonths={2}
        />
        {value?.from != null && (
          <div className="p-2 border-t border-gray-100">
            <Button
              type="button"
              variant="ghost"
              size="sm"
              className="w-full text-gray-600 hover:text-gray-900"
              onClick={() => {
                onChange(undefined);
                setOpen(false);
              }}
            >
              Clear date range
            </Button>
          </div>
        )}
      </PopoverContent>
    </Popover>
  );
};

export default DateRangePicker;
